// District-level beneficiary breakdown — mock data seeded for each state YBF works in.
// District names match those in the India districts TopoJSON (shapeName property).

export const DISTRICT_REACH = {
  "Maharashtra": [
    { district: "Pune",            beneficiaries: 980 },
    { district: "Mumbai",          beneficiaries: 850 },
    { district: "Nashik",          beneficiaries: 620 },
    { district: "Thane",           beneficiaries: 540 },
    { district: "Nagpur",          beneficiaries: 480 },
    { district: "Aurangabad",      beneficiaries: 410 },
    { district: "Solapur",         beneficiaries: 360 },
    { district: "Ahmadnagar",      beneficiaries: 320 },
    { district: "Kolhapur",        beneficiaries: 280 },
    { district: "Satara",          beneficiaries: 220 },
    { district: "Amravati",        beneficiaries: 140 },
  ],
  "Rajasthan": [
    { district: "Jaipur",          beneficiaries: 520 },
    { district: "Udaipur",         beneficiaries: 420 },
    { district: "Jodhpur",         beneficiaries: 380 },
    { district: "Alwar",           beneficiaries: 320 },
    { district: "Ajmer",           beneficiaries: 280 },
    { district: "Kota",            beneficiaries: 240 },
    { district: "Bhilwara",        beneficiaries: 240 },
  ],
  "Gujarat": [
    { district: "Ahmadabad",       beneficiaries: 540 },
    { district: "Surat",           beneficiaries: 420 },
    { district: "Vadodara",        beneficiaries: 380 },
    { district: "Rajkot",          beneficiaries: 320 },
    { district: "Bhavnagar",       beneficiaries: 240 },
  ],
  "Madhya Pradesh": [
    { district: "Bhopal",          beneficiaries: 420 },
    { district: "Indore",          beneficiaries: 380 },
    { district: "Jabalpur",        beneficiaries: 320 },
    { district: "Gwalior",         beneficiaries: 240 },
    { district: "Ujjain",          beneficiaries: 200 },
    { district: "Rewa",            beneficiaries: 140 },
  ],
  "Karnataka": [
    { district: "Bangalore",       beneficiaries: 580 },
    { district: "Mysore",          beneficiaries: 420 },
    { district: "Belgaum",         beneficiaries: 320 },
    { district: "Mangalore",       beneficiaries: 280 },
    { district: "Hubli-Dharwad",   beneficiaries: 250 },
  ],
  "Tamil Nadu": [
    { district: "Chennai",         beneficiaries: 480 },
    { district: "Coimbatore",      beneficiaries: 380 },
    { district: "Madurai",         beneficiaries: 300 },
    { district: "Tiruchirappalli", beneficiaries: 240 },
  ],
  "Uttar Pradesh": [
    { district: "Lucknow",         beneficiaries: 420 },
    { district: "Kanpur Nagar",    beneficiaries: 360 },
    { district: "Varanasi",        beneficiaries: 320 },
    { district: "Allahabad",       beneficiaries: 240 },
    { district: "Agra",            beneficiaries: 160 },
  ],
  "Odisha": [
    { district: "Khordha",         beneficiaries: 480 },
    { district: "Cuttack",         beneficiaries: 420 },
    { district: "Ganjam",          beneficiaries: 380 },
    { district: "Sundargarh",      beneficiaries: 320 },
  ],
  "West Bengal": [
    { district: "Kolkata",         beneficiaries: 480 },
    { district: "Haora",           beneficiaries: 380 },
    { district: "Murshidabad",     beneficiaries: 340 },
  ],
  "Assam": [
    { district: "Kamrup Metropolitan", beneficiaries: 360 },
    { district: "Dibrugarh",       beneficiaries: 280 },
    { district: "Jorhat",          beneficiaries: 260 },
  ],
  "Telangana": [
    { district: "Hyderabad",       beneficiaries: 480 },
    { district: "Rangareddy",      beneficiaries: 370 },
  ],
  "Andhra Pradesh": [
    { district: "Visakhapatnam",   beneficiaries: 380 },
    { district: "Krishna",         beneficiaries: 320 },
  ],
  "Jharkhand": [
    { district: "Ranchi",          beneficiaries: 420 },
    { district: "Dhanbad",         beneficiaries: 360 },
    { district: "Purbi Singhbhum", beneficiaries: 320 },
  ],
  "Bihar": [
    { district: "Patna",           beneficiaries: 480 },
    { district: "Gaya",            beneficiaries: 320 },
  ],
  "Haryana": [
    { district: "Gurgaon",         beneficiaries: 320 },
    { district: "Faridabad",       beneficiaries: 240 },
    { district: "Hisar",           beneficiaries: 190 },
  ],
  "Delhi": [
    { district: "New Delhi",       beneficiaries: 320 },
    { district: "South Delhi",     beneficiaries: 280 },
  ],
  "Uttarakhand": [
    { district: "Dehradun",        beneficiaries: 200 },
    { district: "Nainital",        beneficiaries: 150 },
  ],
  "Punjab": [
    { district: "Ludhiana",        beneficiaries: 300 },
  ],
};
